/**
 * Created by amu33 on 26/09/2016.
 */
import React from "react";
/**
 * Social Menu Item
 * @returns the layout of a Social Menu Item
 * @constructor
 */
const SocialMenuItem = ({type, url}) => {
    return (
        <a href={url} target="_blank">
            <img src={`../../images/icon-${type}.png`} title={`AMCODE on ${type}`} />
        </a>
    );
};

SocialMenuItem.propTypes = {
    type: React.PropTypes.string.isRequired,
    url: React.PropTypes.string.isRequired
};

export default SocialMenuItem;



/** WEBPACK FOOTER **
 ** ./app/components/social-menu/social-menu-item.jsx
 **/